import angular from 'angular';
import template from './template.html';
import './style.scss';
import BaseComponent from '../../base/component';
import { ENGAGEMENT_AFTER_RATING, IMMEDIATE_ENGAGEMENT } from '../../../constants/positionServiceType';

export class PositionServiceTypeLabel extends BaseComponent {
    currentServiceTypeTitle = '';
    isLabelVisible = true;

    $onInit() {
        this.setupValues();
    }

    $onChanges() {
        this.setupValues();
    }

    setupValues() {
        switch (this.serviceType) {
            case IMMEDIATE_ENGAGEMENT:
                this.currentServiceTypeTitle = 'JOB_VIEW_SERVICE_TYPE_STATUS_IMMEDIATE_ENGAGEMENT';
                break;
            case ENGAGEMENT_AFTER_RATING:
                this.currentServiceTypeTitle = 'JOB_VIEW_SERVICE_TYPE_STATUS_ENGAGEMENT_AFTER_RATING';
                break;
            default:
                break;
        }
    }
}

export const config = {
    template,
    bindings: {
        serviceType: '<',
    },
    controller: PositionServiceTypeLabel,
    controllerAs: 'ctrl',
};

angular.module('TALENYA-FE').component('positionServiceTypeLabel', config);
